import { isAbsoluteUrl } from "./isAbsoluteUrl";
/**
 * Check if URL is relative
 * @category Helper
 * @param url
 * @returns
 */
export function isRelativeUrl(url) {
    return !isAbsoluteUrl(url);
}
//# sourceMappingURL=isRelativeUrl.js.map